import React from 'react';

const WriterIcon = () => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0008 0.5C10.7872 0.583437 2.26117 1.39531 1.66515 7.24085C1.59273 7.86569 1.55172 8.49335 1.52476 9.12147L5.71702 4.93343C5.86351 4.78695 6.1014 4.78695 6.24788 4.93343C6.39436 5.07991 6.39436 5.31734 6.24788 5.46382L0.165859 11.5397C-0.0539843 11.7594 -0.0539843 12.1156 0.165859 12.3352C0.385703 12.5548 0.742186 12.5548 0.962264 12.3352L2.30125 10.9976C3.28773 10.9944 4.27351 10.9383 5.25343 10.8251C6.50686 10.6976 7.52733 10.2047 8.36077 9.49998H5.99476L9.43514 8.35436C9.69881 8.00538 9.936 7.6346 10.1488 7.24999H8.2471L10.7441 6.00288C11.7264 3.6139 11.9584 1.11547 12.0008 0.5Z" fill="currentColor" />
  </svg>
);

export default WriterIcon;
